(function($) {
    jQuery(document).ready(function(){
        jQuery('.carousel-main').flickity({
            pageDots: false,
            prevNextButtons: false,
            bgLazyLoad: true,
            imagesLoaded : true,
        });
        jQuery('.carousel-nav').flickity({
            asNavFor: '.carousel-main',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            imagesLoaded : true,
        });
        
        jQuery('.grid-slider').flickity({
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            watchCSS: true,
            imagesLoaded : true,
        });

        // options


        var breakpoint = {};
        breakpoint.refreshValue = function () {
        this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
        };
        
        jQuery(window).resize(function () {
            breakpoint.refreshValue();
            if (breakpoint.value === "tablet"){
                jQuery('.grid-slider').flickity({
                    pageDots: false,
                    prevNextButtons: false,
                });
            }
          }).resize();
        //jQuery('.grid-slider').flickity({
        //});

    });

    var $carousel = $('.carousel-main');
    $carousel.on( 'change.flickity', function( event, index ) {
    var $selector = $('.carousel-cell.is-selected');
        if (jQuery($selector).is(':last-child')){
            jQuery('.carousel-cell:first-child').addClass('first');
        } else {
            jQuery('.carousel-cell:first-child').removeClass('first');
        }
    });
})(jQuery);